import React, {useEffect, useLayoutEffect} from 'react';
import {classes} from '../BillingDetails/BillingDetails.st.css';
import {useControllerProps} from '../../../../../Widget/ControllerContext';
import {useBillingData} from '../../WithBillingData';
import {usePaymentsApi} from '../../../../../../../common/components/WithPaymentsApi/WithPaymentsApi';
import {updateMandatoryFields} from '../../../../../../../domain/utils/cashier.utils';
import {BillingForm} from '../../../../../Form/BillingForm/BillingForm';
import {getCountryFromAddressFormValues} from '../../../../../Form/form.utils';
import {EmailField} from '../../../../../../../common/components/EmailField/EmailField';
import {useLocaleKeys} from '../../../../../../../locale-keys/LocaleKeys';
import {FIELDS_GAP} from '../../../../../constants';
import {SPECS} from '../../../../../../../common/constants';
import {useExperiments} from '@wix/yoshi-flow-editor';

export enum BillingDetailsFormDataHook {
  billingForm = 'BillingDetailsForm.billingForm',
  billingLeanFlowEmail = 'BillingDetailsForm.billingLeanFlowEmail',
}

export const BillingDetailsForm = () => {
  const {
    paymentStore: {setCashierMandatoryFields},
    stepsManagerStore: {isLeanFlow},
  } = useControllerProps();
  const localeKeys = useLocaleKeys();
  const {experiments} = useExperiments();
  const {billingFormData, email, setEmail, isEmailValid, updateContactCountry, overrides} = useBillingData();
  const {paymentsApi} = usePaymentsApi();
  const country = getCountryFromAddressFormValues(billingFormData.formValues);

  const useEffectOrLayoutEffect = experiments.enabled(SPECS.UseLayoutEffectInCheckout)
    ? useLayoutEffect
    : /* istanbul ignore next */ useEffect;

  useEffectOrLayoutEffect(
    () => {
      void updateContactCountry(country);
      if (!experiments.enabled(SPECS.SupportDynamicBillingFieldsCheckout)) {
        void updateMandatoryFields(paymentsApi, setCashierMandatoryFields, country);
      }
    },
    /* eslint-disable react-hooks/exhaustive-deps */ [country]
  );

  return (
    <div
      data-hook={BillingDetailsFormDataHook.billingForm}
      className={classes.forms}
      style={{
        gap: `${FIELDS_GAP}px`,
      }}>
      {isLeanFlow && (
        <EmailField
          dataHook={BillingDetailsFormDataHook.billingLeanFlowEmail}
          label={localeKeys.ecom.email.label()}
          value={email}
          hasError={!isEmailValid}
          onChange={setEmail}
        />
      )}
      <BillingForm overrides={overrides} {...billingFormData} />
    </div>
  );
};
